const defaultAnchorsOptions = {
    brokenImageClass: 'img-broken'
};
export class BrokenImage {
    constructor(win = win, options = {}) {
        this.win = win;
        const opts = Object.assign({}, defaultAnchorsOptions, options);
        this.brokenImageClass = opts.brokenImageClass || 'img-broken';
    }
    activate() {
        const images = this.win.document.querySelectorAll('img');
        images.forEach(img => img.addEventListener('error', () => this.handleBrokenImage(img)));
    }
    handleBrokenImage(image) {
        image.classList.add(this.brokenImageClass);
    }
}
